import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const incidents = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        incidentTypes: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        incidentTypes: (state) => state.incidentTypes,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        INCIDENT_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        INCIDENT_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        INCIDENT_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        INCIDENT_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        INCIDENT_TYPE_SET_ITEMS(state, incidentTypes) {
            Object.assign(state, { incidentTypes })
        },
        INCIDENT_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        INCIDENT_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        INCIDENT_REMOVE_ITEM(state, item) {
            console.log("removeeeee", state.items)
            console.log("itemmmmm", item)
            const index = state.items.findIndex(i => i.id === item.id);
            console.log("indexxx", index)
            state.items.splice(index, 1);
        }
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }, { page, itemsPerPage, sortField, sortOrder, filter }) {
            // TODO EXCEPTION HANDLING
            filter.cityCode = authstore.getters.jwtDecoded(authstore.state).city_code;
            console.log("get place store filter", filter)         
            let body = {
                pageNumber: page,
                pagesize: itemsPerPage,
                sortField: sortField,
                sortOrder: sortOrder,
                searchCriteria: filter,
            }
            console.log("store getitems before")

            await clients.placeServiceClient.searchIncidents(body)
                .then((res) => res.data)
                .then((data) =>
                    commit('INCIDENT_SET_ITEMS', data)
                )
            console.log("store getitems after")

        },
        async getIncidentTypes({ commit }) {
            console.log("get incidenttypee store filter")

            await clients.placeServiceClient.getIncidentTypes()
                .then((res) => res.data)
                .then((data) =>
                    commit('INCIDENT_TYPE_SET_ITEMS', data)
                )
            console.log("store incidenttypee after")

        },
        async create({ commit }, place) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                incidentTypeId: place.incidentTypeId,
                description: place.description,
                cityCode: jwt.city_code,
                countyCode: place.countyCode,
                neighborhoodCode: place.neighborhoodCode,
                lat: place.lat,
                lon: place.lon,
                startTime: place.startDate,
                endTime: place.endDate
            }

            console.log("store addddd before")
            await clients.placeServiceClient.addIncident(body);
            console.log("store addddd after")
            //commit('PLACE_CREATE_ITEM', body);
        },
        async update({ commit }, incident) {
            console.log("Incident Update Request", incident)
            let body = {
                incidentId: incident.incidentId,
                description: incident.description,
                startTime: incident.startDate,
                endTime: incident.endDate,
                lat: incident.lat,
                lon: incident.lon,
            }
            console.log("Incident Body:" , body)
            await clients.placeServiceClient.updateIncident(body);
            
        },
        async remove({ commit }, place) {
            console.log("placeeeeeeeeeeeeeidddd", place.item.id)
            await clients.placeServiceClient.deleteIncident(place.item.id);
            commit('INCIDENT_REMOVE_ITEM', place.item);
        },

        async uploadPlaceAsset({ commit }, place) {
            console.log("upppppppppload", place.id)
            console.log("upppppppppload", place.file)
            let file = {
                data: place.file,
                fileName: place.file.name
            }
            await clients.placeServiceClient.uploadPlaceAsset(place.id, file);
            //commit('PLACE_UPLOAD_ASSET', place.item);
        }
    }
}

export default incidents;